export const defaultIndexCol = {
  key: 'index',
  label: '#',
  sortable: false,
  enabledByDefault: true,
  class: 'sticky-left',
};
